import React from 'react';
import * as yup from 'yup';
import { useStringsContext } from '../../../../../contexts/strings';
import { QuizPoll, QuizPollKeys } from '../../types';
import PollCard from '../poll-card';
import TextInputWithValidate, {
  InputWithValidateProps,
} from '../../../../common/input/text-input-with-validate';
import Stack from '@mui/material/Stack';

const titleKey: QuizPollKeys = 'title';
const descriptionKey: QuizPollKeys = 'description';

interface Props extends InputWithValidateProps {
  selectedPoll: QuizPoll | null;
  title: string;
  label?: string;
}

const PollDescriptionCard = ({
  selectedPoll,
  title,
  label,
  onValue,
  onValidation,
  hideValidationError,
}: Props) => {
  const { strings } = useStringsContext();

  return (
    <PollCard title={title} label={label}>
      <Stack spacing={2}>
        <TextInputWithValidate
          name={titleKey}
          validation={yup.string()}
          label={strings.polls.quizTitleLabel}
          value={selectedPoll?.[titleKey]}
          onValue={onValue}
          onValidation={onValidation}
          hideValidationError={hideValidationError}
          helperText={strings.polls.quizTitleHelperText}
        />
        <TextInputWithValidate
          name={descriptionKey}
          validation={yup.string()}
          label={strings.polls.quizDescriptionLabel}
          value={selectedPoll?.[descriptionKey]}
          onValue={onValue}
          onValidation={onValidation}
          hideValidationError={hideValidationError}
          helperText={strings.polls.quizDescriptionHelperText}
          multiline
          minRows={3}
          maxRows={3}
        />
      </Stack>
    </PollCard>
  );
};

export default PollDescriptionCard;
